import { Language, LanguageMarshaller } from 'app/constants/enums/Language';
import { TranslationsForEntity, ALL_TRANSLATIONS } from 'app/constants/schemas/translations';
import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntity, IEntityType } from 'app/types/entity';

export interface ISentenceTranslation extends IEntity {
  attributes: {
    id: EntityStringId;
    language: Language;
    translation: string;
  };
}

export type SentenceTranslation = Entity<ISentenceTranslation>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SentenceTranslation: IEntityType<ISentenceTranslation> = vmClient.defineClass({
  typeName: 'SentenceTranslation',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    translation: {
      type: 'string',
      notNull: true,
    },
  },
});

export const SentenceTranslationFieldTranslations: Partial<TranslationsForEntity<ISentenceTranslation>> = {
  language: {
    getLabel: (t) => t('entity-fields.SentenceTranslation.language.label'),
  },
  translation: {
    getLabel: (t) => t('entity-fields.SentenceTranslation.translation.label'),
    getInlineLabel: (t) => t('entity-fields.SentenceTranslation.translation.inline-label'),
  },
};

ALL_TRANSLATIONS.set(SentenceTranslation, SentenceTranslationFieldTranslations);
